import { render, staticRenderFns } from "./PluggedChargingSessions.vue?vue&type=template&id=424bd8a4&"
import script from "./PluggedChargingSessions.vue?vue&type=script&lang=ts&"
export * from "./PluggedChargingSessions.vue?vue&type=script&lang=ts&"
import style0 from "./PluggedChargingSessions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VContainer})
